// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1Zrdi","actionsCol":"EnrolledClinics_actionsCol__2h2KS"};